var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "form",
      staticClass: "app-container view-container",
      attrs: {
        "label-position": "top",
        model: _vm.form,
        rules: _vm.rules,
        "label-width": "120px",
      },
    },
    [
      [
        _c(
          "BjDivider",
          {
            scopedSlots: _vm._u([
              {
                key: "button",
                fn: function () {
                  return [
                    _c(
                      "div",
                      { staticClass: "ml5 mt20" },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { prop: "purchaseType" } },
                          [
                            _c("BjSelectLov", {
                              attrs: {
                                disabled: _vm.isEdit,
                                "option-list": _vm.PURCHASE_TYPE,
                              },
                              on: { change: _vm.changeLov },
                              model: {
                                value: _vm.form.purchaseType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "purchaseType", $$v)
                                },
                                expression: "form.purchaseType",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                },
                proxy: true,
              },
              {
                key: "right",
                fn: function () {
                  return [
                    _c("el-button", { on: { click: _vm.handleClose } }, [
                      _vm._v(_vm._s(_vm.$t("cancelText"))),
                    ]),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.handleConfirm },
                      },
                      [_vm._v(_vm._s(_vm.$t("okText")))]
                    ),
                  ]
                },
                proxy: true,
              },
            ]),
          },
          [
            _vm._v(
              " " + _vm._s(_vm.$t("BusinessPurchaseComponentsPur.type")) + " "
            ),
          ]
        ),
      ],
      [
        _c(
          "BjDivider",
          [
            _vm._v(
              " " +
                _vm._s(_vm.$t("BusinessPurchaseComponentsCom.PO.title")) +
                " "
            ),
            !_vm.isEdit
              ? [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        disabled: !_vm.form.purchaseType,
                      },
                      on: { click: _vm.addPurchase },
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "BusinessPurchaseComponentsCom.PO.selectPurchase"
                          )
                        )
                      ),
                    ]
                  ),
                ]
              : _vm._e(),
          ],
          2
        ),
        _vm.isPurchase
          ? _c(
              "el-table",
              {
                attrs: {
                  data: _vm.form.orderList,
                  border: "",
                  script: "",
                  "max-height": "600",
                },
              },
              [
                _c("el-table-column", {
                  attrs: {
                    prop: "code",
                    label: _vm.$t("BusinessPurchaseComponentsCom.PO.code"),
                    width: "180",
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "typeMeaning",
                    width: "120",
                    label: _vm.$t(
                      "BusinessPurchaseComponentsCom.PO.typeMeaning"
                    ),
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "statusMeaning",
                    width: "100",
                    label: _vm.$t(
                      "BusinessPurchaseComponentsCom.PO.statusMeaning"
                    ),
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "stockinStatusMeaning",
                    width: "120",
                    label: _vm.$t(
                      "BusinessPurchaseComponentsCom.PO.stockinStatusMeaning"
                    ),
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "supplierName",
                    width: "100",
                    label: _vm.$t(
                      "BusinessPurchaseComponentsCom.PO.supplierName"
                    ),
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "creationDate",
                    label: _vm.$t("table.createTimeText"),
                    align: "center",
                    width: "140",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "planQty",
                    width: "140",
                    label: _vm.$t("BusinessPurchaseComponentsCom.PO.planQty"),
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "amount",
                    width: "170",
                    label: _vm.$t("BusinessPurchaseComponentsCom.PO.amount"),
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "alreadyQty",
                    width: "140",
                    label: _vm.$t(
                      "BusinessPurchaseComponentsCom.PO.alreadyQty"
                    ),
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "cancelQty",
                    width: "160",
                    label: _vm.$t("BusinessPurchaseComponentsCom.PO.cancelQty"),
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "remark",
                    label: _vm.$t("table.remarkText"),
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "buyerName",
                    width: "100",
                    label: _vm.$t("BusinessPurchaseComponentsCom.PO.buyerName"),
                    align: "center",
                  },
                }),
              ],
              1
            )
          : _vm._e(),
      ],
      [
        _c("BjDivider", [
          _vm._v(
            " " +
              _vm._s(_vm.$t("BusinessPurchaseComponentsCom.baseMsg.title")) +
              " "
          ),
        ]),
        _c(
          "el-row",
          [
            _c(
              "el-col",
              { attrs: { span: _vm.colSpan } },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label:
                        "" +
                        _vm.text(2) +
                        _vm.$t(
                          "BusinessPurchaseComponentsCom.baseMsg.oddNumber"
                        ),
                      prop: "code",
                    },
                  },
                  [
                    _c("BjInput", {
                      attrs: {
                        disabled: "",
                        placeholder: _vm.$t(
                          "BusinessPurchaseComponentsCom.baseMsg.automatic"
                        ),
                        maxlength: _vm.MAX_LENGTH.DEFAULT,
                      },
                      model: {
                        value: _vm.form.code,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "code", $$v)
                        },
                        expression: "form.code",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-col",
              { attrs: { span: _vm.colSpan } },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label:
                        "" +
                        _vm.text(2) +
                        _vm.$t("BusinessPurchaseComponentsCom.baseMsg.type"),
                      prop: "type",
                    },
                  },
                  [
                    _c("BjSelectLov", {
                      attrs: {
                        disabled: _vm.isPurchase,
                        "lov-code": _vm.enter
                          ? "SPUR.STOCKIN_TYPE"
                          : "SPUR.STOCKOUT_TYPE",
                      },
                      model: {
                        value: _vm.form.type,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "type", $$v)
                        },
                        expression: "form.type",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-col",
              { attrs: { span: _vm.colSpan } },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("table.statusText"),
                      prop: "status",
                    },
                  },
                  [
                    _c("BjInput", {
                      attrs: {
                        disabled: "",
                        maxlength: _vm.MAX_LENGTH.DEFAULT,
                      },
                      model: {
                        value: _vm.form.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "status", $$v)
                        },
                        expression: "form.status",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-col",
              { attrs: { span: _vm.colSpan } },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t(
                        "BusinessPurchaseComponentsCom.baseMsg.supplier"
                      ),
                      prop: "supplierCode",
                    },
                  },
                  [
                    _c("BjSelectSupplier", {
                      attrs: {
                        "option-value": "code",
                        "default-options": {
                          label: _vm.form.supplierName,
                          value: _vm.form.supplierCode,
                        },
                        disabled: _vm.isPurchase || _vm.isEdit,
                      },
                      on: { change: _vm.onChangeSupplier },
                      model: {
                        value: _vm.form.supplierCode,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "supplierCode", $$v)
                        },
                        expression: "form.supplierCode",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-col",
              { attrs: { span: _vm.colSpan } },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t(
                        "BusinessPurchaseComponentsPur.postingDate"
                      ),
                      prop: "postingDate",
                    },
                  },
                  [
                    _c("BjDatePicker", {
                      model: {
                        value: _vm.form.postingDate,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "postingDate", $$v)
                        },
                        expression: "form.postingDate",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-col",
              { attrs: { span: _vm.colSpan } },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t(
                        "BusinessPurchaseComponentsPur.expectedDate"
                      ),
                      prop: "requiredDate",
                    },
                  },
                  [
                    _c("BjDatePicker", {
                      model: {
                        value: _vm.form.requiredDate,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "requiredDate", $$v)
                        },
                        expression: "form.requiredDate",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-col",
              { attrs: { span: _vm.colSpan } },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t(
                        "BusinessPurchaseComponentsPur.documentDate"
                      ),
                      prop: "documentDate",
                    },
                  },
                  [
                    _c("BjDatePicker", {
                      model: {
                        value: _vm.form.documentDate,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "documentDate", $$v)
                        },
                        expression: "form.documentDate",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-col",
              { attrs: { span: _vm.colSpan } },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("BusinessPurchaseComponentsCom.invoiceNo"),
                      prop: "invoiceNo",
                    },
                  },
                  [
                    _c("BjInput", {
                      attrs: {
                        maxlength: _vm.MAX_LENGTH.DEFAULT,
                        placeholder: _vm.$t("inputText"),
                      },
                      model: {
                        value: _vm.form.invoiceNo,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "invoiceNo", $$v)
                        },
                        expression: "form.invoiceNo",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-col",
              { attrs: { span: _vm.colSpan } },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t(
                        "BusinessPurchaseComponentsPur.vendorRefNo"
                      ),
                      prop: "vendorRefNo",
                    },
                  },
                  [
                    _c("BjInput", {
                      attrs: {
                        maxlength: _vm.MAX_LENGTH.DEFAULT,
                        placeholder: _vm.$t("inputText"),
                      },
                      model: {
                        value: _vm.form.vendorRefNo,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "vendorRefNo", $$v)
                        },
                        expression: "form.vendorRefNo",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-col",
              { attrs: { span: _vm.colSpan } },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("BusinessPurchaseComponentsPur.remark"),
                      prop: "remark",
                    },
                  },
                  [
                    _c("BjInput", {
                      attrs: {
                        autosize: "",
                        type: "textarea",
                        "show-word-limit": "",
                        placeholder: _vm.$t("table.remarkText"),
                      },
                      model: {
                        value: _vm.form.remark,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "remark", $$v)
                        },
                        expression: "form.remark",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      [
        _c(
          "div",
          { staticClass: "bj-row", staticStyle: { "margin-bottom": "0" } },
          [
            _c(
              "BjDivider",
              [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$t("BusinessPurchaseComponentsCom.commodityMsg.title")
                    ) +
                    " "
                ),
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        disabled: !_vm.form.supplierCode,
                        type: "primary",
                      },
                      on: { click: _vm.onImport },
                    },
                    [_vm._v(_vm._s(_vm.$t("EXCELImportText")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "warning",
                        plain: "",
                        disabled: _vm.selection.length === 0,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.onDelete()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("delText")))]
                  ),
                  !_vm.spreadVisible
                    ? _c(
                        "el-button",
                        {
                          attrs: {
                            type: "warning",
                            disabled: _vm.selection.length === 0,
                            plain: "",
                          },
                          on: { click: _vm.onPackUp },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "BusinessPurchaseComponentsCom.onPackUpBtn"
                              )
                            )
                          ),
                        ]
                      )
                    : _c(
                        "el-button",
                        {
                          attrs: { type: "warning", plain: "" },
                          on: { click: _vm.onSpread },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "BusinessPurchaseComponentsCom.onSpreadBtn"
                              )
                            )
                          ),
                        ]
                      ),
                ],
              ],
              2
            ),
            _c(
              "div",
              {
                staticClass: "bj-col bj-col-24",
                staticStyle: { "border-left": "none" },
              },
              [
                _c(
                  "el-table",
                  {
                    attrs: {
                      "row-class-name": _vm.tableRowClassName,
                      data: _vm.form.goodsList,
                      border: "",
                      script: "",
                      "max-height": "600px",
                    },
                    on: { "selection-change": _vm.handleSelectionChange },
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("table.countText"),
                        type: "index",
                        width: "65",
                        fixed: "left",
                        align: "center",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        type: "selection",
                        width: "70",
                        align: "center",
                        fixed: "left",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("BusinessPurchaseComponentsCom.PO.code"),
                        prop: "code",
                        align: "center",
                        width: "175",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "skuCode",
                        label: "SKU",
                        align: "center",
                        width: "160",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "temporaryQty",
                        label: _vm.$t(
                          "BusinessPurchaseComponentsCom.alreadyQty"
                        ),
                        align: "center",
                        width: "155",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (ref) {
                            var row = ref.row
                            return [
                              _c("BjInputNumber", {
                                staticClass: "full-width",
                                attrs: { min: 0, controls: false },
                                model: {
                                  value: row.temporaryQty,
                                  callback: function ($$v) {
                                    _vm.$set(row, "temporaryQty", $$v)
                                  },
                                  expression: "row.temporaryQty",
                                },
                              }),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "taxUnitPrice",
                        label: _vm.$t(
                          "BusinessPurchaseComponentsPur.table.UnitPrice"
                        ),
                        align: "center",
                        width: "120",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (ref) {
                            var row = ref.row
                            return [
                              _c("BjInputMoney", {
                                staticClass: "full-width",
                                attrs: { min: 0, controls: false },
                                model: {
                                  value: row.taxUnitPrice,
                                  callback: function ($$v) {
                                    _vm.$set(row, "taxUnitPrice", $$v)
                                  },
                                  expression: "row.taxUnitPrice",
                                },
                              }),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "planQty",
                        label: _vm.$t(
                          "BusinessPurchaseComponentsCom.allPlanQty"
                        ),
                        align: "center",
                        width: "125",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "alreadyQty",
                        label: _vm.$t(
                          "BusinessStockEntryResult.table.alreadyQty"
                        ),
                        align: "center",
                        width: "75",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "waitQty",
                        label: _vm.$t(
                          "BusinessPurchaseEntryComPage.table.waitQty"
                        ),
                        align: "center",
                        width: "100",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "discount",
                        label: _vm.$t(
                          "BusinessPurchaseComponentsPur.table.Discount"
                        ),
                        align: "center",
                        width: "130",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (ref) {
                            var row = ref.row
                            return [
                              _c(
                                "BjInputNumber",
                                {
                                  attrs: { placeholder: _vm.$t("chooseText") },
                                  model: {
                                    value: row.discount,
                                    callback: function ($$v) {
                                      _vm.$set(row, "discount", $$v)
                                    },
                                    expression: "row.discount",
                                  },
                                },
                                [
                                  _c("template", { slot: "append" }, [
                                    _vm._v("%"),
                                  ]),
                                ],
                                2
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "taxCode",
                        label: _vm.$t(
                          "BusinessPurchaseComponentsPur.table.TaxCode"
                        ),
                        align: "center",
                        width: "100",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (ref) {
                            var row = ref.row
                            return [
                              _c(
                                "el-select",
                                {
                                  model: {
                                    value: row.taxCode,
                                    callback: function ($$v) {
                                      _vm.$set(row, "taxCode", $$v)
                                    },
                                    expression: "row.taxCode",
                                  },
                                },
                                _vm._l(_vm.options, function (item) {
                                  return _c("el-option", {
                                    key: item.value,
                                    attrs: {
                                      label: item.label,
                                      value: item.value,
                                    },
                                  })
                                }),
                                1
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "grossPriceAfterDisc",
                        label: _vm.$t(
                          "BusinessPurchaseComponentsPur.table.GrosSprice"
                        ),
                        align: "center",
                        width: "132",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "totalPrice",
                        label: _vm.$t(
                          "BusinessPurchaseComponentsPur.table.Total"
                        ),
                        align: "center",
                        width: "140",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t(
                          "BusinessPurchaseComponentsPur.table.Warehouse"
                        ),
                        align: "center",
                        width: "130",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (ref) {
                            var row = ref.row
                            return [
                              _c("BjSelectWarehouse", {
                                attrs: {
                                  "value-code": "code",
                                  "type-code": ["logic"],
                                },
                                model: {
                                  value: row.warehouse,
                                  callback: function ($$v) {
                                    _vm.$set(row, "warehouse", $$v)
                                  },
                                  expression: "row.warehouse",
                                },
                              }),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "length",
                        label: _vm.$t(
                          "BusinessPurchaseComponentsPur.table.Length"
                        ),
                        align: "center",
                        width: "130",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (ref) {
                            var row = ref.row
                            return [_vm._v(" " + _vm._s(row.length) + " cm ")]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "width",
                        label: _vm.$t(
                          "BusinessPurchaseComponentsPur.table.Width"
                        ),
                        align: "center",
                        width: "130",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (ref) {
                            var row = ref.row
                            return [_vm._v(" " + _vm._s(row.width) + " cm ")]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "height",
                        label: _vm.$t(
                          "BusinessPurchaseComponentsPur.table.Height"
                        ),
                        align: "center",
                        width: "130",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (ref) {
                            var row = ref.row
                            return [_vm._v(" " + _vm._s(row.height) + " cm ")]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "volume",
                        label: _vm.$t(
                          "BusinessPurchaseComponentsPur.table.Volume"
                        ),
                        align: "center",
                        width: "130",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (ref) {
                            var row = ref.row
                            return [
                              _vm._v(
                                " " +
                                  _vm._s(row.length * row.width * row.height) +
                                  " "
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c(
                      "el-table-column",
                      {
                        attrs: {
                          prop: "volumeUnit",
                          label: _vm.$t(
                            "BusinessPurchaseComponentsPur.table.VolumeUnit"
                          ),
                          align: "center",
                          width: "120",
                        },
                      },
                      [_vm._v(" cm³ ")]
                    ),
                    _c("el-table-column", {
                      attrs: {
                        prop: "weight",
                        label: _vm.$t(
                          "BusinessPurchaseComponentsPur.table.Weight"
                        ),
                        align: "center",
                        width: "130",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (ref) {
                            var row = ref.row
                            return [_vm._v(" " + _vm._s(row.weight) + " kg ")]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "uomCode",
                        label: _vm.$t(
                          "BusinessPurchaseComponentsPur.table.UomCode"
                        ),
                        align: "center",
                        width: "130",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (ref) {
                            var row = ref.row
                            return [
                              _c("BjInput", {
                                staticClass: "full-width",
                                attrs: { min: 0, controls: false },
                                model: {
                                  value: row.uomCode,
                                  callback: function ($$v) {
                                    _vm.$set(row, "uomCode", $$v)
                                  },
                                  expression: "row.uomCode",
                                },
                              }),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "",
                        label: _vm.$t("table.operationText"),
                        align: "center",
                        fixed: "right",
                        width: "120",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (ref) {
                            var row = ref.row
                            var $index = ref.$index
                            return [
                              _c(
                                "el-button",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.onDelete(row, $index)
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("delText")))]
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
                _vm.form.goodsList.length
                  ? _c(
                      "div",
                      {
                        staticClass: "bj-form-tips",
                        staticStyle: { "margin-top": "15px" },
                      },
                      [
                        _c("div", [
                          _c("span", { staticClass: "mr20" }, [
                            _vm._v("Total Before Discount: "),
                            _c("span", { staticClass: "font16 ml10" }, [
                              _vm._v(_vm._s(_vm.totalBefore)),
                            ]),
                          ]),
                          _vm._v(" Total Payment Due:"),
                          _c("span", { staticClass: "font16 ml10" }, [
                            _vm._v(_vm._s(_vm.totalPayment)),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "ml25" }),
                          _vm._v(" Tax: "),
                          _c("span", { staticClass: "font16 ml10" }, [
                            _vm._v(_vm._s(_vm.taxComputed) + " "),
                          ]),
                        ]),
                      ]
                    )
                  : _vm._e(),
              ],
              1
            ),
            _vm.form.purchaseType !== "COMMON" && _vm.form.goodsList.length > 0
              ? [
                  _c("BjDivider", [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "BusinessPurchaseComponentsPur.table.FreightInformation"
                        )
                      )
                    ),
                  ]),
                  _c(
                    "el-table",
                    {
                      attrs: {
                        border: "",
                        script: "",
                        "max-height": "600px",
                        data: _vm.freight,
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          prop: "freightName",
                          label: _vm.$t(
                            "BusinessPurchaseComponentsPur.table.FreightName"
                          ),
                          align: "center",
                          width: "130",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "taxGroup",
                          label: _vm.$t(
                            "BusinessPurchaseComponentsPur.table.TaxGroup"
                          ),
                          align: "center",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (ref) {
                                var row = ref.row
                                return [
                                  _c(
                                    "el-select",
                                    {
                                      on: { change: _vm.taxChange },
                                      model: {
                                        value: row.taxGroup,
                                        callback: function ($$v) {
                                          _vm.$set(row, "taxGroup", $$v)
                                        },
                                        expression: "row.taxGroup",
                                      },
                                    },
                                    _vm._l(_vm.options, function (item) {
                                      return _c("el-option", {
                                        key: item.value,
                                        attrs: {
                                          label: item.label,
                                          value: item.value,
                                        },
                                      })
                                    }),
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2602590964
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "tax",
                          label: _vm.$t(
                            "BusinessPurchaseComponentsPur.table.Tax"
                          ),
                          align: "center",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "netAmount",
                          label: _vm.$t(
                            "BusinessPurchaseComponentsPur.table.NetAmount"
                          ),
                          align: "center",
                          width: "160",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (ref) {
                                var row = ref.row
                                return [
                                  _c(
                                    "el-input-number",
                                    {
                                      staticClass: "full-width",
                                      attrs: { min: 0, controls: false },
                                      on: {
                                        change: function ($event) {
                                          return _vm.autoNetAmount(row)
                                        },
                                      },
                                      model: {
                                        value: row.netAmount,
                                        callback: function ($$v) {
                                          _vm.$set(row, "netAmount", $$v)
                                        },
                                        expression: "row.netAmount",
                                      },
                                    },
                                    [
                                      _c("template", { slot: "prepend" }, [
                                        _vm._v("AUD"),
                                      ]),
                                    ],
                                    2
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          4130536155
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "distribMethod",
                          label: _vm.$t(
                            "BusinessPurchaseComponentsPur.table.DistribMethod"
                          ),
                          align: "center",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (ref) {
                                var row = ref.row
                                return [
                                  _vm._v(" " + _vm._s(row.distribMethod) + " "),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3691940691
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "totalTax",
                          label: _vm.$t(
                            "BusinessPurchaseComponentsPur.table.TotalTaxAmount"
                          ),
                          align: "center",
                          width: "160",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (ref) {
                                var row = ref.row
                                return [
                                  _c(
                                    "el-input-number",
                                    {
                                      staticClass: "full-width",
                                      attrs: {
                                        min: 0,
                                        disabled: row.tax === 0,
                                        controls: false,
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.autoTotalTaxAmount(row)
                                        },
                                      },
                                      model: {
                                        value: row.totalTaxAmount,
                                        callback: function ($$v) {
                                          _vm.$set(row, "totalTaxAmount", $$v)
                                        },
                                        expression: "row.totalTaxAmount",
                                      },
                                    },
                                    [
                                      _c("template", { slot: "prepend" }, [
                                        _vm._v("AUD"),
                                      ]),
                                    ],
                                    2
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2832110937
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "status",
                          label: _vm.$t("table.statusText"),
                          align: "center",
                          width: "120",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "grossAmount",
                          label: _vm.$t(
                            "BusinessPurchaseComponentsPur.table.GrossAmount"
                          ),
                          align: "center",
                          width: "160",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (ref) {
                                var row = ref.row
                                return [
                                  _c(
                                    "el-input-number",
                                    {
                                      staticClass: "full-width",
                                      attrs: { min: 0, controls: false },
                                      on: {
                                        change: function ($event) {
                                          return _vm.autoGrossAmount(row)
                                        },
                                      },
                                      model: {
                                        value: row.grossAmount,
                                        callback: function ($$v) {
                                          _vm.$set(row, "grossAmount", $$v)
                                        },
                                        expression: "row.grossAmount",
                                      },
                                    },
                                    [
                                      _c("template", { slot: "prepend" }, [
                                        _vm._v("AUD"),
                                      ]),
                                    ],
                                    2
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          668445179
                        ),
                      }),
                    ],
                    1
                  ),
                ]
              : _vm._e(),
          ],
          2
        ),
      ],
      _c("BjDialogList", {
        ref: "dialogOrderList",
        attrs: {
          multiple: _vm.isPurchaseType,
          width: "80%",
          config: _vm.$BjDialogListConfig["purchaseOrderDefault"](
            _vm.$t("BusinessPurchaseComponentsCom.bjDialogText"),
            {
              defaultQuery: {
                statusList: _vm.enter ? "IN_PROD" : "WAIT_STOCKIN,COMPLETED",
                type: _vm.queryPurchaseType,
              },
            }
          ),
          "tag-name": "code",
        },
        on: { confirm: _vm.onAddDialogConfirm },
      }),
      _c("BjDialogList", {
        ref: "dialogGoodsList",
        attrs: { width: "80%", config: _vm.dialogGoodsConfig, multiple: "" },
        on: { confirm: _vm.onAddDialogGoodsConfirm },
      }),
      _c("BjDialogList", {
        ref: "dialogPurchaseGoodsList",
        attrs: {
          width: "80%",
          res: "goodsList",
          "is-list": "",
          "search-btn-hide": "",
          config: _vm.dialogPurchaseGoodsConfig,
          multiple: "",
        },
        on: { confirm: _vm.onAddDialogGoodsConfirm },
        scopedSlots: _vm._u([
          {
            key: "tableTop",
            fn: function () {
              return [
                _c("p", { staticClass: "mb16" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t("BusinessPurchaseComponentsCom.purchaseCode")
                    ) +
                      "：" +
                      _vm._s(_vm.form.purchaseCode)
                  ),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("ExcelImportDialog", {
        ref: "ExcelImport",
        attrs: { "purchase-data-list": _vm.form.goodsList },
        on: { submit: _vm.getTableData },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }